module.exports = __webpack_public_path__ + "static/media/feelingProud.5ce67573.png";